import React from 'react';
import PropTypes from 'prop-types';
import { pageContext } from 'ctm-util-functions';
import Immutable from 'immutable';
import { BrandLogo, ModalContainer, Text, SimpleFlexbox } from 'ctm-components';
import style from './special_conditions.css';

/**
 * Displays a special condition(s) Modal Container with link
 * @param {Object} props The component props
 * @returns {SpecialConditions} A SpecialCondition Component
 * @constructor
 */
const SpecialConditions = (props) => {
    const modalVisualProps = {
        contentVariant: 'padded',
        outerVariant: 'centered',
        containerVariant: 'centered',
        overlayVariant: 'dark'
    };
    const { stateProps, contentProps, openComponent } = props;
    const { product } = stateProps;
    const { title, text } = contentProps;
    const vertical = pageContext.getVertical();
    const brandLogoElementProps = { srcPath: `/evt/assets/images/logos/${vertical}` };
    const providerToShow = contentProps.providerToShowFor;

    if (providerToShow && product.getIn(['providerMeta', 'code']) !== providerToShow) {
        return null;
    }

    return (
        <ModalContainer
            stateProps={{ isOpen: false }}
            openComponent={openComponent}
            visualProps={modalVisualProps}
        >
            <SimpleFlexbox display="flex">
                <BrandLogo stateProps={{ product }} elementProps={brandLogoElementProps} />
                <h3 className={style.modal_title}>{title}</h3>
            </SimpleFlexbox>
            <Text innerHTML={text} />
        </ModalContainer>
    );
};

SpecialConditions.propTypes = {
    stateProps: PropTypes.shape({
        product: PropTypes.instanceOf(Immutable.Map)
    }),
    contentProps: PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.string,
        providerToShowFor: PropTypes.string
    }),
    openComponent: PropTypes.array
};

SpecialConditions.defaultProps = {
    stateProps: {
        product: Immutable.Map()
    }
};

export { SpecialConditions };
